import { createContext, useContext, useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const ProductsContext = createContext({ guides: {}, bundle: {}, tools: {}, freebies: {} });

export const ProductsProvider = ({ children }) => {
  const [data, setData] = useState({ guides: {}, bundle: {}, tools: {}, freebies: {} });

  useEffect(() => {
    const load = async () => {
      try {
        const [bundleRes, toolsRes, freebiesRes, starterRes] = await Promise.all([
          fetch(`${API_URL}/api/products/bundle`),
          fetch(`${API_URL}/api/tools`),
          fetch(`${API_URL}/api/freebies`),
          fetch(`${API_URL}/api/products/glp-quick-start-kit`),
        ]);

        let guidesMap = {};
        let bundleData = {};
        let toolsMap = {};
        let freebiesMap = {};

        if (bundleRes.ok) {
          bundleData = await bundleRes.json();
          (bundleData.guides || []).forEach(g => { guidesMap[g.id] = g; });
        }
        if (starterRes.ok) {
          const s = await starterRes.json();
          guidesMap[s.slug] = { ...s, price: s.price / 100, category: s.type };
        }
        if (toolsRes.ok) {
          const td = await toolsRes.json();
          (td.tools || []).forEach(t => { toolsMap[t.id] = t; });
        }
        if (freebiesRes.ok) {
          const fd = await freebiesRes.json();
          (fd.freebies || []).forEach(f => { freebiesMap[f.id] = f; });
        }

        setData({ guides: guidesMap, bundle: bundleData, tools: toolsMap, freebies: freebiesMap });
      } catch (err) {
        console.error("Failed to load product data", err);
      }
    };
    load();
  }, []);

  return <ProductsContext.Provider value={data}>{children}</ProductsContext.Provider>;
};

export const useProducts = () => useContext(ProductsContext);
